import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import PublicContent from './components/PublicContent'
import { AuthProvider } from './services/AuthProvider'
import StoreConfigureProvider from './services/StoreConfigureProvider/StoreConfigureProvider'
import { regModal } from './utils/controllers/ModalController'
import Login from './views/Login/Login'

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1080000, // 5 минут в миллисекундах
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  regModal('progress-backdrop')

  return (
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <StoreConfigureProvider>
            <Routes>
              <Route
                path={'/login'}
                element={
                  <PublicContent>
                    <Login />
                  </PublicContent>
                }
              />
              <Route path={'/*'} element={<Layout />} />
            </Routes>
          </StoreConfigureProvider>
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
